/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Link as ReactRouterLink } from 'react-router';

import { Grid, Link, Typography2 } from '@coursera/cds-core';

import { resourceOrder, root } from 'bundles/directory-graphql/common/constants';
import type { ResourceName } from 'bundles/directory-graphql/common/constants';

import _t from 'i18n!nls/directory-graphql';

const styles = {
  directorySection: css`
    padding-top: 20px;
    min-height: 200px;
    display: block;

    &:last-child {
      border-left: rgb(0 0 0 / 6%);
      margin-left: -1px;
    }
  `,
  searchFor: css`
    border-right: 1px solid rgb(0 0 0 / 6%);
    padding-bottom: 50px;

    @media (max-width: 767px) {
      text-align: center;
      width: 100%;
    }
  `,
  sectionHeading: css`
    font-weight: bold;
    margin-bottom: 16px;
  `,
  resourceNavItemContainer: css`
    /* stylelint-disable-line no-empty-source */
  `,
  resourceButton: css`
    display: inline-block !important;
  `,
  selected: css`
    font-weight: bold;
    margin-bottom: 0;
  `,
  menuText: css`
    line-height: 21px;
  `,
  titleColumn: css`
    position: relative;
    min-height: 1px;
    padding-left: 15px;
    padding-right: 15px;

    @media (min-width: 768px) {
      width: 25%;
      float: left;
    }
  `,
};

type ResourceNavItemProps = {
  resource: ResourceName;
  label: string;
  selected: boolean;
};

const ResourceNavItem = ({ resource, label, selected }: ResourceNavItemProps) => {
  return (
    <Grid item>
      {selected ? (
        <Typography2 component="p" variant="bodyPrimary" css={[selected && styles.selected, styles.menuText]}>
          {label}
        </Typography2>
      ) : (
        <Link
          variant="quiet"
          component={ReactRouterLink}
          css={[styles.resourceButton, styles.menuText]}
          to={`${root}/${resource}`}
          typographyVariant="bodyPrimary"
        >
          {label}
        </Link>
      )}
    </Grid>
  );
};

type PropsToComponent = { selectedResource: string };
const ResourceNav = ({ selectedResource }: PropsToComponent) => {
  return (
    <Grid item container css={[styles.directorySection, styles.searchFor, styles.menuText, styles.titleColumn]}>
      <Typography2 component="p" variant="bodyPrimary" css={[styles.sectionHeading]}>
        {_t('Search for:')}
      </Typography2>
      {resourceOrder.map((resource) => (
        <ResourceNavItem
          resource={resource.name}
          label={resource.displayName}
          selected={selectedResource === resource.name}
          key={resource.name}
        />
      ))}
    </Grid>
  );
};

export default ResourceNav;
